import { useDispatch } from "react-redux";
import { OVERLAY_SET_DATA } from "~/redux/actions/types";

const useOverlay = () => {
    const dispatch = useDispatch();

    const setOverlay = (data) =>
        dispatch({
            type: OVERLAY_SET_DATA,
            payload: data,
        });

    const reset = () =>
        dispatch({
            type: OVERLAY_SET_DATA,
            payload: {
                title: null,
                content: null,
                show: false,
                onClose: () => {},
            },
        });

    return [setOverlay, reset];
};

export default useOverlay;
